<template>
	<div class="my-lg-2 mb-4 mb-lg-0">
		<div v-if="showLabel" class="mb-4 d-flex align-items-center justify-content-between mb-2">
			<p class="mb-0 fs-24 fw-bold whitespace-nowrap">{{ showAll ? 'Total' : 'My' }} Puzzle Progress</p>
			<div class="form-check d-flex form-switch mb-0 fs-14 d-flex align-items-center flex-row-reverse">
                <input id="showAllSwitch" v-model="showAll" class="form-check-input form-check-input-lg" type="checkbox">
                <label for="showAllSwitch" class="form-check-label me-6 fs-14 fw-bold text-capitalize"></label>
			</div>
		</div>
		<div class="d-flex align-items-center">
			<div>
                <div :class="getMetric('pieces') > 0 ? 'border-success active' : 'border-primary-200'"
                     class="fs-24 fs-md-48 fw-bold border rounded-circle metric-stepper has-partner position-relative d-flex justify-content-center align-items-center mb-2 text-uppercase">
                    {{ getMetric('pieces') }}
                    <div class="arrow">
                        <div class="arrow-left d-md-none position-absolute top-50"></div>
                        <div class="arrow-bridge position-absolute top-50"></div>
                        <div class="arrow-right position-absolute top-50"></div>
                    </div>
                </div>
				<p class="mb-0 fs-18 fw-bold text-secondary text-center">Pieces</p>
			</div>

			<div>
                <div :class="getMetric('rows') > 0 ? 'border-success active' : 'border-primary-200'"
                     class="fs-24 fs-md-48 fw-bold border rounded-circle metric-stepper has-partner position-relative d-flex justify-content-center align-items-center mb-2 text-uppercase">
                    {{ getMetric('rows') }}
                    <div class="arrow">
                        <div class="arrow-left d-md-none position-absolute top-50"></div>
                        <div class="arrow-bridge position-absolute top-50"></div>
                        <div class="arrow-right position-absolute top-50"></div>
                    </div>
                </div>
				<p class="mb-0 fs-18 fw-bold text-secondary text-center">Rows</p>
			</div>

			<div>
				<div :class="getMetric('collectibles') > 0 ? 'border-success active' : 'border-primary-200'"
				     class="fs-24 fs-md-48 fw-bold border rounded-circle metric-stepper position-relative d-flex justify-content-center align-items-center mb-2 text-uppercase">
					{{ getMetric('pfps') }}
				</div>
				<p class="mb-0 fs-18 fw-bold text-secondary text-center">Pictures</p>
			</div>

		</div>
	</div>
</template>

<script>
import NftCollectibleHelper from '@/Mixins/NftCollectibleHelper'

export default {
	name: 'MetricsProgressComponent',

	props: {
		metrics: {
			required: false,
			type: Object
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		showTotalProgress: {
			type: Boolean,
			default: false
		}
	},

	mixins: [NftCollectibleHelper],

	data() {
		return {
			showAll: this.showTotalProgress,
		}
	},

	methods: {
		getMetric(type) {
			if (Object.keys(this.metrics).length === 0) return 0
			return this.showAll ? this.metrics.totalParticipantsProgress[type] : this.metrics.authenticatedUserProgress[type]
		}
	}
}
</script>
